import api from "./client";

export async function getWorkCenterQueue(workCenterId) {
  const res = await api.get("/work-center-queue", {
    params: { work_center_id: workCenterId },
  });
  return res.data.data;
}

export async function getAvailableOperations(workCenterId) {
  const res = await api.get("/work-center-queue/available", {
    params: { work_center_id: workCenterId },
  });
  return res.data.data;
}

export async function saveWorkCenterQueue(workCenterId, items) {
  const res = await api.post("/work-center-queue", {
    work_center_id: workCenterId,
    items,
  });
  return res.data.data;
}

export async function getAllQueues() {
  const res = await api.get("/work-center-queue/all");
  return res.data.data;
}

export async function validateProductionPlanImport(rows) {
  const res = await api.post("/work-center-queue/import/validate", { rows });
  return res.data.data;
}

export async function importProductionPlan(rows) {
  const res = await api.post("/work-center-queue/import", { rows });
  return res.data.data;
}
